
/**
 *  Usage:
 *  <jv-modal-wrapper show-modal="changeStatusModal.show" on-close="closeModal('changeStatusModal')" modal-title="Change Status">
 *      <!-- Content required for the modal something like below -->
 *      <div>
 *         <p>Modal Content</p>
 *      </div
 *  </jv-modal-wrapper>
 */

angular.module('jv.Common.ModalWrapper', [])
    .directive('jvModalWrapper', function() {
        return {
            restrict: 'E',
            transclude: true,
            scope: {
                modalTitle: '@',
                confirmModal: '@',
                showModal: '=',
                onClose: '&'
            },
            template: `
                <div class="jv-modal-wrapper" ng-class="{ 'show': showModal}">
                    <div class="base" ng-class="{ 'confirm-base': confirmModal }">
                        <div class="header" ng-class="{ 'confirm-header': confirmModal }">
                            <h4> {{ modalTitle }} </h4>
                            <a ng-hide="confirmModal" title="Close" ng-click="close()">
                                <i class="icon icon-close jv-modal-icon-close"></i>
                            </a>
                        </div>
                        <div ng-transclude></div>
                    </div>
                </div>
            `,
            link: function(scope, element) {
                const document = element?.[0]?.ownerDocument;
                document?.body?.classList?.add('no-scroll');
                scope.close = function() {
                    scope.onClose();
                };
            }
        };
    });